import { FormProvider, useForm } from "react-hook-form";
import { useListDropdownSchedule, useListRegister } from "../../hooks";
import { useFilterStore } from "../../stores";
import { FormType } from "../../schemas";
import { FilterDetail } from "./FilterDetail";
import { formatForm } from "../../functions";
import { Table } from "../Action";
import { useEffect } from "react";

export function Detail({
    idSchedule
}: {
    idSchedule: string
}) {

    // state
    const { filter, resetFilter } = useFilterStore();

    useEffect(() => {
        resetFilter();

        // eslint-disable-next-line
    }, []);

    // hooks
    const { data, isLoading } = useListRegister({
        shift_schedule_id: idSchedule,
        ...filter
    });
    const { data: schedule } = useListDropdownSchedule({});

    const dataSchedule = schedule?.find(item => Number(item.value) === Number(idSchedule))

    const startDate = dataSchedule?.periode_start;
    const endDate = dataSchedule?.periode_end;


    // useForm
    const method = useForm<FormType>({
        defaultValues: {
            code: "",
            detail: []
        }
    })

    useEffect(() => {
        if (!data) return;

        const formatted = formatForm(data, undefined, filter.shift_schedule_id);

        method.reset({
            code: dataSchedule?.trx_code,
            detail: formatted
        });

        // eslint-disable-next-line
    }, [data]);



    return (
        <div>
            <FormProvider {...method}>
                <div className="my-5">
                    <FilterDetail
                        start_date={startDate!}
                        end_date={endDate!}
                    />
                </div>

                <div>
                    <Table
                        data={data}
                        isLoading={isLoading}
                        method={method}
                        start_date={startDate!}
                        end_date={endDate!}
                    />
                </div>
            </FormProvider>
        </div>
    )
}